import styled from 'styled-components';
import { layers, transitions, layout, breakpoints } from '../../theme';

export const Wrapper = styled.div`
  left: ${layout.SPACING}rem;
  height: ${layout.SPACING * 1.5}rem;
  opacity: ${props => (props.isActive ? 1 : 0)};
  position: fixed;
  top: ${layout.SPACING}rem;
  transition: opacity ${transitions.PANES}, transform ${transitions.PANES},
    visibility ${transitions.PANES};
  transform: scale(${props => (props.isActive ? 1 : 0.75)});
  visibility: ${props => (props.isActive ? 'visible' : 'hidden')};
  width: ${layout.SPACING * 1.5}rem;
  z-index: ${layers.HOME_BUTTON};

  @media ${breakpoints.MOBILE__MQ} {
    display: none;
  }

  a {
    border: none;
    bottom: 0;
    cursor: pointer;
    left: 0;
    overflow: hidden;
    position: absolute;
    right: 0;
    text-indent: -9999rem;
    top: 0;

    &:before,
    &:after {
      background: currentColor;
      content: '';
      height: 100%;
      left: 50%;
      position: absolute;
      top: 50%;
      transform-origin: center;
      width: 2px;
    }

    &:before {
      transform: translate(-50%, -50%) rotateZ(-45deg);
    }
    &:after {
      transform: translate(-50%, -50%) rotateZ(45deg);
    }
  }
`;
